import name from './name'

const selectSliceData = state => state[name]
const selectTotal = state => selectSliceData(state).total
const selectContent = state => selectSliceData(state).content
const selectContentList = state => selectSliceData(state).list
const selectContentListStartAt = state => selectSliceData(state).startAt

export { selectTotal, selectContent, selectContentList, selectContentListStartAt }
